import { render, staticRenderFns } from "./I18nConfig.vue?vue&type=template&id=4226e8dd&scoped=true&"
import script from "./I18nConfig.vue?vue&type=script&lang=js&"
export * from "./I18nConfig.vue?vue&type=script&lang=js&"
import style0 from "./I18nConfig.vue?vue&type=style&index=0&id=4226e8dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4226e8dd",
  null
  
)

export default component.exports